export const modalContactFormInit = () => {
  if(document.querySelector('.modal-contact-form')) {
    const modalForm = document.querySelector('.modal-contact-form');
    const modalFormClose = modalForm.querySelector('.modal-form__close');
    const ctaContactBtns = document.querySelectorAll('.cta-contact__form');

    if(ctaContactBtns) {
      ctaContactBtns.forEach((ctaContactBtn) => {
        ctaContactBtn.addEventListener('click', (e) => {
          modalForm.style.display = 'block';
          document.body.classList.add('no-scroll');
        });
      });
    }

    if(modalFormClose) {
      modalFormClose.addEventListener('click', (e) => {
        modalForm.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });
    }

    document.addEventListener('click', (e) => {
      if(!e.target.closest('.modal-form__inner') && !e.target.matches('.cta-contact__form')) {
        modalForm.style.display = 'none';
        document.body.classList.remove('no-scroll');
      }
    });
  }
}